module.exports = __webpack_public_path__ + "img/banner.ca859484.webp";